function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.67 10.73a3.52 3.52 0 00-.94 1.93 5 5 0 00-.07 1.1v.58h.8a5.05 5.05 0 00.88-.08 3.46 3.46 0 001.93-.94 1.76 1.76 0 00-.14-2.48 1.76 1.76 0 00-2.46-.11zm1.74 1.73a2.26 2.26 0 01-1.26.6h-.22v-.22a2.26 2.26 0 01.6-1.26.36.36 0 01.24-.08.67.67 0 01.47.22.54.54 0 01.17.74zM14.65 2.24a.91.91 0 00-.89-.89A8.75 8.75 0 007.27 3.5L5.64 5.4l-2.4-.5a1 1 0 00-.92.27l-.68.68a1 1 0 00-.28.81 1 1 0 00.45.74l2.06 1.32.13.08 3.2 3.25.08.08 1.32 2.06a1 1 0 00.74.45h.11a1 1 0 00.7-.29l.68-.68a1 1 0 00.27-.92l-.5-2.39 1.84-1.58a8.79 8.79 0 002.21-6.54zM3.11 6.15l1.32.28-.64.75-1-.67zm6.38 7.1l-.67-1 .75-.64.28 1.32zm2.39-5.11l.18.17zm-.28-.28L7.92 11 5 8.08 8.14 4.4a7.44 7.44 0 015.26-1.8 7.48 7.48 0 01-1.8 5.26z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.13 6.63a1.19 1.19 0 00-.06-1.7 1.16 1.16 0 10-1.64 1.63 1.2 1.2 0 001.7.07z"
});

var SvgRocket2 = function SvgRocket2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#9193A9",
    width: 16,
    height: 16
  }, props), _ref, _ref2);
};

export default SvgRocket2;